var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "master-card 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 35.0028C24.5228 35.0028 29 30.5257 29 25.0028C29 19.48 24.5228 15.0028 19 15.0028C13.4772 15.0028 9 19.48 9 25.0028C9 30.5257 13.4772 35.0028 19 35.0028Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31 15.0028C28.754 15.0028 26.688 15.7528 25.02 17.0028H25V17.0168C24.604 17.3148 24.24 17.6508 23.893 18.0028H26.107C26.415 18.3158 26.699 18.6508 26.962 19.0028H23.03C22.788 19.3218 22.566 19.6548 22.363 20.0028H27.627C27.815 20.3268 27.992 20.6568 28.145 21.0028H21.854C21.711 21.3278 21.585 21.6608 21.477 22.0028H28.521C28.625 22.3288 28.707 22.6638 28.779 23.0028H21.216C21.149 23.3308 21.093 23.6628 21.059 24.0028H28.94C28.979 24.3308 29 24.6638 29 25.0028H21C21 25.3418 21.027 25.6728 21.06 26.0028H28.942C28.904 26.3418 28.849 26.6748 28.78 27.0028H21.217C21.286 27.3438 21.375 27.6758 21.478 28.0028H28.522C28.414 28.3448 28.288 28.6778 28.145 29.0028H21.854C22.005 29.3468 22.175 29.6808 22.363 30.0028H27.627C27.425 30.3508 27.2 30.6838 26.958 31.0028H23.03C23.296 31.3548 23.583 31.6898 23.892 32.0028H26.107C25.759 32.3558 25.396 32.6908 25 32.9888C26.672 34.2478 28.745 35.0028 31 35.0028C36.523 35.0028 41 30.5248 41 25.0028C41 19.4808 36.523 15.0028 31 15.0028Z",
    fill: "#009ADE"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard2);
export default __webpack_public_path__ + "static/media/mastercard2.378431d2326a1fd50e819147efd0888a.svg";
export { ForwardRef as ReactComponent };